import { IVideoPlayerComponent } from "front-end/components/video-box/factories/video-player.component";
import { IVideoPlayerFactory } from "front-end/components/video-box/factories/video-player.factory";
import { VideoPlayerFactoryBase } from "front-end/components/video-box/factories/video-player.factory.base";
import { VimeoPlayerComponent } from "front-end/components/video-box/factories/vimeo/vimeo-player.component";
import { scriptLoaderService } from "front-end/services/scripts-loader.service";
import { mergeMap, Observable, Subject } from "rxjs";
import * as Vimeo from "vimeo__player";

class VimeoVideoPlayerFactory extends VideoPlayerFactoryBase implements IVideoPlayerFactory {
    public createPlayer(frameId: string): Observable<IVideoPlayerComponent> {
        const videoFrameElement =  this.setupFrame(frameId);

        return scriptLoaderService.loadScript("https://player.vimeo.com/api/player.js")
            .pipe(
                mergeMap(() => {
                    const player = new VimeoPlayerComponent();

                    const playerReadySubject = new Subject<IVideoPlayerComponent>();

                    // eslint-disable-next-line
                    const internalPlayer = new (<any>window).Vimeo.Player(videoFrameElement.attr("id")) as Vimeo.Player;

                    internalPlayer.ready()
                        .then(() => {
                            player.init(internalPlayer);
                            playerReadySubject.next(player);
                            playerReadySubject.complete();
                        })
                        .catch(() => {
                            throw new Error(`Failed to initialize Vimeo player ${frameId}`);
                        });

                    return playerReadySubject.asObservable();
                })
            );
    }
}

export const vimeoVideoPlayerFactory = new VimeoVideoPlayerFactory();
